import { render } from "./VODUploadWidgetDrop.vue?vue&type=template&id=4dffb148&scoped=true"
import script from "./VODUploadWidgetDrop.vue?vue&type=script&lang=js"
export * from "./VODUploadWidgetDrop.vue?vue&type=script&lang=js"

import "./VODUploadWidgetDrop.vue?vue&type=style&index=0&id=4dffb148&scoped=true&lang=css"
import "./VODUploadWidgetDrop.vue?vue&type=style&index=1&id=4dffb148&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dffb148"]])

export default __exports__